class DateUtil {
  constructor (date) {
    if (window.navigator.userAgent.includes('Safari') && typeof date === 'string') {
      date = date.replace(/-/g, '/')
      return new Date(date)
    }
    return new Date(date)
  }
}
export default DateUtil
